// src/lib/auth-client.ts
import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";
import { getBetterAuthSessionToken } from "@/utils/auth/tokenManager";

export const API_URL =
    import.meta.env.VITE_REACT_APP_API_URL || // Vite
    (process.env.REACT_APP_API_URL as string) || // CRA / other
    "https://dev-socket.pullseai.com/api"; // fallback

console.log("API_URL", API_URL);

export const authClient = createAuthClient({
    baseURL: API_URL + "/auth",
    fetchOptions: {
        credentials: "include",
        async onRequest(context) {
            const token = getBetterAuthSessionToken();
            if (token) {
                context.headers.set("Authorization", `Bearer ${token}`);
            }
        }
    },
    plugins: [organizationClient()],
});

// export the most commonly used helpers/hooks
export const {
    signIn,
    signUp,
    signOut,
    useSession,
    useActiveOrganization,
    useActiveMember,
    useActiveMemberRole,
    organization,
    updateUser,
    listSessions,
    revokeSession,
} = authClient;
